<template>
  <div class="my-4 text-center">
    <img src="#" alt="404" />
    Nao Autorizado
  </div>
</template>

<script>
export default {
  name: "NotFound",
};
</script>
